var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRequestDeleteMagnet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 60,
    viewBox: "0 0 61 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 30,
    r: 29.5,
    fill: "#4EBBB8",
    fillOpacity: 0.02,
    stroke: "#4EBBB8"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19273_207812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.5659 20.1656L29.6708 16.3014C29.2689 15.8995 28.6197 15.8995 28.2179 16.3014L25.4356 19.1145L30.7528 24.4317L33.5659 21.6185C33.9678 21.2167 33.9678 20.5675 33.5659 20.1656ZM44.6948 31.2945L40.8306 27.4303C40.4287 27.0284 39.7795 27.0284 39.3777 27.4303L36.5645 30.2434L41.8817 35.5606L44.6948 32.7474C45.0967 32.3456 45.0967 31.6964 44.6948 31.2945ZM35.1116 31.6964L31.5565 35.2514C29.949 36.859 27.3523 36.859 25.7448 35.2514C24.1373 33.6439 24.1373 31.0472 25.7448 29.4397L29.2998 25.8846L23.9827 20.5675L20.4276 24.1226C15.8833 28.6359 15.8524 35.9934 20.3967 40.5686C22.5916 42.7635 25.5593 44 28.6816 44C31.7729 44 34.7406 42.7635 36.9046 40.5686L40.4596 37.0135L35.1116 31.6964Z",
    fill: "#4EBBB8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19273_207812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(17 16)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRequestDeleteMagnet);
export default __webpack_public_path__ + "static/media/request-delete-magnet.6daa49e0d9a0096897ee837b6976ff6b.svg";
export { ForwardRef as ReactComponent };